customElements.define('sticky-product-form', class StickyProductForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.productForm = document.querySelector('product-form');
        this.productStickyForm = document.querySelector('.product--sticky-form');
        
        // Assume the ATC button has a specific class or ID
        this.atcButton = document.querySelector('.product-form .product-form__submit');
        
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const atcButtonBottom = this.atcButton.getBoundingClientRect().bottom;
        const viewportHeight = window.innerHeight;

        if (atcButtonBottom < 0) {
            requestAnimationFrame(this.reveal.bind(this));
        } else {
            requestAnimationFrame(this.hide.bind(this));
        }
    }

    hide() {
        if (this.productStickyForm.classList.contains('product--sticky-form__active')) {
            this.productStickyForm.classList.remove('product--sticky-form__active');
            this.productStickyForm.classList.add('product--sticky-form__inactive');
            document.getElementById('chat-button').style.height = '66px';
            document.getElementById('ae-popup-video-pdp').style.bottom = '20px';
        }
    }

    reveal() {
        if (this.productStickyForm.classList.contains('product--sticky-form__inactive')) {
            this.productStickyForm.classList.add('product--sticky-form__active');
            this.productStickyForm.classList.remove('product--sticky-form__inactive');
            document.getElementById('chat-button').style.height = '170px';
            document.getElementById('ae-popup-video-pdp').style.bottom = '120px';
        }
    }
});
